import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { StingFitLanding } from './pages/StingFitLanding';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<StingFitLanding data-id="element-3" />} data-id="element-2" />
        <Route path="/stingfit" element={<StingFitLanding data-id="element-5" />} data-id="element-4" />
      </Routes>
    </Router>;
}